import { useState } from "react";
import { useAnalysisOrder } from "../redux/ReduxContext";

export default function AnalysisOrderTags() {
    const { state, dispatch } = useAnalysisOrder();
    const [newTag, setNewTag] = useState("");

    const handleAddNewTag = () => {
        const trimmedTag = newTag.trim();
        if (!trimmedTag || state.tags.some(tag => tag.toLowerCase() === trimmedTag.toLowerCase())) {
            setNewTag("");
            return;
        }
        dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'tags', item: trimmedTag } });
        setNewTag("");
    };

    const removeTag = (value: string) => {
        const index = state.tags.findIndex(tag => tag.toLowerCase() === value.toLowerCase());
        if (index !== -1) {
            dispatch({ type: 'DELETE_ARRAY_ITEM', payload: { field: 'tags', index } });
        }
    };

    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md dark:drop-shadow-none text-primary-dark dark:text-primary-light">
            <h6 className="mb-2 text-sm font-bold">Tags</h6>
            <div className="flex gap-2 w-full">
                <div className="relative w-full">
                    <input
                        type="text"
                        placeholder="ie. grain size"
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAddNewTag();
                            }
                        }}
                        className="h-12 w-full p-2 pr-20 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-oi-button-blue border bg-primary-light dark:bg-oi-dark-background border-primary-dark/70 dark:border-primary-light/50 text-primary-dark dark:text-oi-powder-form-yellow placeholder-gray-400 dark:placeholder-gray-300"
                    />
                    <button className="absolute right-2 top-1/2 -translate-y-1/2 px-3 py-1 bg-oi-button-blue text-primary-light mt-1 h-8" onClick={handleAddNewTag}>Add</button>
                </div>
            </div>

            <div className="mt-4">
                {state.tags.length === 0 ? (
                    <p className="text-primary-dark/70 dark:text-primary-light text-sm">No tags added yet.</p>
                ) : (
                    <div className="flex flex-wrap gap-3">
                        {state.tags.map((tag, index) => (
                            <label key={index} className="flex items-center gap-2 cursor-pointer hover:bg-primary-dark/10 dark:hover:bg-primary-light/10 p-2 rounded transition-colors">
                                <input
                                    type="checkbox"
                                    checked
                                    aria-label={`Remove tag ${tag}`}
                                    onChange={() => removeTag(tag)}
                                    className="w-4 h-4"
                                />
                                <span className="text-sm text-primary-dark dark:text-primary-light select-none">{tag}</span>
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
